export const colors = {
  white: '#FFFFFF',
  mainDark: '#040325',
  darkYellow: '#EB9A2D',
  mainColor: '#FFB100',
  aliceBlue2: '#E8EFF4',
  ghostWhite: '#F4F7FC',
  ghostWhite2: '#EDF1FA',
  backgroundColour: '#FFFFFF',
  secondaryBackColor: '#FCFCF2',
  testBackground: '#F5F7EE',
  antiFlashWhite: '#f0f2f5',
  imageBackground: '#F6F8FB',
  transparent: 'transparent',
  textColor: '#0B090A',
  bodyTextColor: '#6C6D84',
  secondaryTextColor: '#666666',
  qacheGreen: '#19535F',
  paleYellow: '#FAF7E8',
  qacheRed: '#EE2B44',
  
};

export const theme = {colors};
